import { useEffect, useState } from "react";

import { type Countdown, parseCountdown } from "./parse-countdown";

function getRemainingMs(expiresAt: Date | string): number {
  const target =
    typeof expiresAt === "string" ? new Date(expiresAt) : expiresAt;
  return Math.max(0, target.getTime() - Date.now());
}

export function useCountdown(expiresAt: Date | string): Countdown {
  const [remainingMs, setRemainingMs] = useState(() =>
    getRemainingMs(expiresAt),
  );
  const targetTime = new Date(expiresAt).getTime();
  const [prevTargetTime, setPrevTargetTime] = useState(targetTime);

  if (!Object.is(prevTargetTime, targetTime)) {
    setPrevTargetTime(targetTime);
    setRemainingMs(getRemainingMs(expiresAt));
  }

  useEffect(() => {
    setRemainingMs(getRemainingMs(expiresAt));

    const interval = setInterval(() => {
      setRemainingMs(getRemainingMs(expiresAt));
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  return { ms: remainingMs, ...parseCountdown(remainingMs) };
}
